exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nothing[data-v-e58ef460]{width:100%;text-align:center;padding:75px 0 0}.nothing img[data-v-e58ef460]{width:100%;margin:20px 0 30px}.tip1[data-v-e58ef460]{font-size:18px}.tip2[data-v-e58ef460]{font-size:13px;margin-bottom:10px}.btn[data-v-e58ef460]{padding:5px 0;display:block;width:45%;margin:0 auto;background:#268e87;border-radius:3px;color:#fff;font-size:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e58ef460","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mybook.vue
// module id = 93
// module chunks = 0